import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ComponentSize } from '@omgui/component-size';
import { OmguiSpinnerModule } from '@omgui/omgui-spinner/omgui-spinner.component';

@Component({
  selector: 'om-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  standalone: true,
  imports: [CommonModule, OmguiSpinnerModule],
})
export class LoadingSpinnerComponent {
  @Input() message: string;

  readonly componentSize = ComponentSize;
}
